export default __webpack_public_path__ + "media/images/check-ae560310.svg";